import { ComponentType } from 'react';

export const withChunkRetry = (
  fn: () => Promise<{ default: ComponentType<any> }>,
  retriesLeft = 5,
  interval = 1000,
): Promise<{ default: ComponentType<any> }> => {
  return new Promise<{ default: ComponentType<any> }>((resolve, reject) => {
    fn()
      .then(resolve)
      .catch((error: unknown) => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            reject(error);

            return;
          }

          withChunkRetry(fn, retriesLeft - 1, interval).then(resolve, reject);
        }, interval);
      });
  });
};
